import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, unref as _unref } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "text-left"
};
const _hoisted_5 = {
  class: "text-left"
};
const _hoisted_6 = {
  src: "/img/check.svg"
};
const _hoisted_7 = {
  src: "/img/check.svg"
};
const _hoisted_8 = {
  style: {
    "color": "#888"
  }
};
const _hoisted_9 = {
  class: "w-1/4"
};
const _hoisted_10 = {
  class: "text-truncate"
};
const _hoisted_11 = {
  class: "text-truncate"
};
const _hoisted_12 = {
  class: "mt-6"
};
const _hoisted_13 = {
  key: 0,
  class: "alert alert-success mt-2"
};
const _hoisted_14 = {
  key: 1
};
import { onMounted, reactive } from 'vue';
import MainHeader from '@/components/MainHeader.vue';
import { useCompanyBillingStore } from './companyBillingStore.js';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import Loader from '@/components/Loader.vue';
import ProductNotice from '@/components/ProductNotice.vue';
import { useCustomFieldStore } from '@/services/customFieldStore.js';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import RouteService from '@/services/RouteService';
export default {
  __name: 'CustomFields',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const customFieldsState = reactive({
      accounts: [],
      filter: true,
      leanlawCustomFields: [],
      selectedCustomField: null,
      form: {
        customFields: []
      },
      users: [],
      accountingCustomFields: [],
      qboav: false,
      disableDropdowns: false,
      customFields: [],
      me: {},
      loading: false,
      saving: false,
      somethingChanged: false,
      unsaved: false
    });
    const companyBillingStore = useCompanyBillingStore();
    const customFieldStore = useCustomFieldStore();
    companyBillingStore.alerts = props.alerts;
    onMounted(async () => {
      customFieldsState.loading = true;
      try {
        const me = await props.userService.getMe();
        customFieldsState.me = me;

        // Backwards compatibility: convert invoiceFields (obsolete) to customFields (new)
        if (me.company?.settings?.invoiceFields?.length) {
          me.company.settings.customFields = me.company.settings.invoiceFields.map(cf => ({
            active: true,
            accountingId: cf.invoiceField.id,
            name: cf.invoiceField.name,
            valueType: 'text',
            customFieldId: cf.content,
            values: cf.invoiceField.values.map(value => ({
              accountingId: value.id,
              name: value.name,
              leanlawId: value.content
            }))
          }));
          me.company.settings.invoiceFields = undefined;
        }

        // Execute all API calls in parallel
        const [listCustomFields, getAccountingSettings, getAccountingStatus, listUsers, listMatterTags] = await Promise.all([customFieldStore.listCustomFields(), customFieldStore.getAccountingSettings(), customFieldStore.verify(false), props.userService.list(), customFieldStore.listMatterTags()]);

        // Process results
        customFieldsState.leanlawCustomFields = Array.isArray(listCustomFields) ? listCustomFields : [];
        customFieldsState.users = listUsers;
        customFieldsState.qboav = getAccountingStatus.qboav;
        customFieldStore.matterTags = listMatterTags.mattertags;
        customFieldsState.accountingCustomFields = (getAccountingSettings?.customFields || []).map(field => ({
          ...field,
          active: field.active,
          map: field.map || null,
          valueTypeLabel: getValueTypeLabel(field.valueType),
          applies: {
            clients: (field.categories || []).indexOf('customer') >= 0,
            invoices: (field.categories || []).indexOf('invoice') >= 0
          }
        }));

        // Configure dropdowns and prepare data
        customFieldsState.disableDropdowns = customFieldsState.qboav && !me?.features?.custom;
        prepare(me?.company?.settings);

        // Set up navigation protection
        const deactivate = new RouteService(props).rootScopeChange().$on('$stateChangeStart', event => {
          if (customFieldsState.somethingChanged) {
            customFieldsState.unsaved = true;
            setTimeout(() => {
              customFieldsState.unsaved = false;
            }, 4000);
            event.preventDefault();
          } else {
            deactivate();
          }
        });
      } catch (error) {
        props.alerts?.error(error);
      } finally {
        customFieldsState.loading = false;
      }
    });
    const prepare = settings => {
      customFieldsState.somethingChanged = false;
      customFieldsState.customFields = customFieldsState.accountingCustomFields?.map(accountingField => {
        const field = {
          ...accountingField
        };
        if (!settings.customFields) return field;
        let mapped = settings.customFields.find(cf => cf.accountingId === field.id);
        if (!mapped) {
          mapped = settings.customFields.find(cf => cf.name === field.name);
        }
        if (mapped && mapped.customFieldId) {
          const llfield = customFieldsState.leanlawCustomFields.find(cf => cf.id === mapped.customFieldId);
          if (llfield) {
            field.active = mapped.active;
            field.map = {
              id: mapped.customFieldId,
              type: llfield.type,
              name: llfield.name
            };
            field.values = (field.values || []).map(value => {
              const mappedValue = mapped.values.find(v => v.accountingId === value.id);
              if (mappedValue) {
                // Find the actual user or matter tag object to get the display name
                let displayObject = null;
                if (llfield.type === 'user') {
                  displayObject = customFieldsState.users.find(user => user.id === mappedValue.leanlawId);
                } else if (llfield.type === 'matterTag') {
                  displayObject = customFieldStore.matterTags.find(tag => tag.id === mappedValue.leanlawId);
                }
                return {
                  ...value,
                  map: displayObject || {
                    id: mappedValue.leanlawId,
                    name: mappedValue.name || 'Unknown'
                  }
                };
              }
              return value;
            });
          }
        }
        return field;
      });
    };
    const changeLeanLawCustomField = field => {
      customFieldsState.somethingChanged = true;
    };
    const handleFieldMapChange = (value, field) => {
      field.map = value;
      field.active = !!value;
      changeLeanLawCustomField(value);
    };

    // Custom field filter - equivalent to Angular customFieldFilter
    const getFilteredCustomFields = field => {
      if (!customFieldsState.leanlawCustomFields || !field) {
        return [];
      }
      return customFieldsState.leanlawCustomFields.filter(cf => {
        return valueTypeMatch(cf, field.valueType) && invoiceOnlyMatch(cf, field.invoiceOnly);
      });
    };
    const valueTypeMatch = (field, valueType) => {
      // Text QB fields can map to any LeanLaw field type
      if (valueType === 'text') return true;

      // Exact type matches
      if (field.type === valueType) return true;

      // Enum QB fields can map to user or matterTag LeanLaw fields
      if (valueType === 'enum' && (field.type === 'user' || field.type === 'matterTag')) {
        return true;
      }
      return false;
    };
    const invoiceOnlyMatch = (field, invoiceOnly) => {
      return !invoiceOnly || field.categories && field.categories.indexOf('invoice') >= 0;
    };
    function getValueTypeLabel(valueType) {
      return {
        enum: 'Dropdown',
        number: 'Number',
        date: 'Date',
        text: 'Text'
      }[valueType] || 'Unknown';
    }
    const update = async () => {
      customFieldsState.saving = true;
      const customFields = customFieldsState.customFields.filter(cf => cf.map && cf.map.id).map(cf => {
        const fieldData = {
          active: Boolean(cf.active),
          valueType: cf.valueType,
          name: cf.name,
          accountingId: cf.id,
          customFieldId: cf.map && cf.map.id
        };

        // Only include values if they exist and have mapped items
        if (cf.values) {
          const mappedValues = cf.values.filter(v => v.map && v.map.id).map(v => ({
            accountingId: v.id,
            leanlawId: v.map.id,
            name: v.name
          }));
          if (mappedValues.length > 0) {
            fieldData.values = mappedValues;
          }
        }
        return fieldData;
      });
      customFieldStore.update(customFields).then(updated => {
        customFieldsState.saving = false;
        props.alerts?.success('Custom fields updated successfully');
        customFieldsState.somethingChanged = false;
        prepare(updated.settings);
      }).catch(err => {
        props.alerts?.error(err);
        customFieldStore.saving = false;
      }).finally(() => {
        customFieldStore.saving = false;
      });
    };
    const cancel = () => {
      prepare(customFieldsState.me?.company?.settings);
      customFieldsState.somethingChanged = false;
    };
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_table = _resolveComponent("v-table");
      return _openBlock(), _createElementBlock(_Fragment, null, [customFieldsState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'custom fields from QuickBooks',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(MainHeader, {
        content: 'Custom Field Mapping'
      }), customFieldsState?.customFields?.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_v_table, null, {
        default: _withCtx(() => [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[3] || (_cache[3] = _createElementVNode("th", {
          class: "text-left"
        }, "Active", -1)), _cache[4] || (_cache[4] = _createElementVNode("th", {
          class: "text-left"
        }, "QuickBooks Custom Field", -1)), _cache[5] || (_cache[5] = _createElementVNode("th", {
          class: "text-left"
        }, "Type", -1)), _createElementVNode("th", _hoisted_4, " Client/" + _toDisplayString(customFieldsState.me?.terms?.matter), 1), _cache[6] || (_cache[6] = _createElementVNode("th", {
          class: "text-left"
        }, "Invoice", -1)), _cache[7] || (_cache[7] = _createElementVNode("th", {
          class: "text-left"
        }, "LeanLaw Value", -1)), _withDirectives(_createElementVNode("th", _hoisted_5, null, 512), [[_vShow, !customFieldsState.disableDropdowns]])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFieldsState.customFields, field => {
          return _openBlock(), _createElementBlock("tbody", {
            key: field.name
          }, [_createElementVNode("tr", null, [_createElementVNode("td", null, [_createVNode(LlCheckbox, {
            modelValue: field.active,
            "onUpdate:modelValue": $event => field.active = $event,
            disabled: !field.map,
            onCheckboxClick: _cache[0] || (_cache[0] = $event => changeLeanLawCustomField())
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]), _createElementVNode("td", null, _toDisplayString(field.name), 1), _createElementVNode("td", null, _toDisplayString(field.valueTypeLabel), 1), _createElementVNode("td", null, [_withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_vShow, field?.applies?.clients]]), _withDirectives(_createElementVNode("span", null, "-", 512), [[_vShow, !field?.applies?.clients]])]), _createElementVNode("td", null, [_withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [[_vShow, field?.applies?.invoices]]), _withDirectives(_createElementVNode("span", null, "-", 512), [[_vShow, !field?.applies?.invoices]])]), _withDirectives(_createElementVNode("td", _hoisted_8, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
            class: "fa fa-warning"
          }, null, -1), _createTextVNode(" LeanLaw Pro Feature ", -1)]))], 512), [[_vShow, field.valueType == 'enum' && customFieldsState.disableDropdowns]]), _withDirectives(_createElementVNode("td", _hoisted_9, [_createVNode(_component_v_card_text, {
            class: "py-2"
          }, {
            default: _withCtx(() => [customFieldsState.leanlawCustomFields ? (_openBlock(), _createBlock(_component_v_autocomplete, {
              key: 0,
              items: getFilteredCustomFields(field),
              "item-value": "id",
              "item-title": "name",
              modelValue: field.map,
              "onUpdate:modelValue": [$event => field.map = $event, value => handleFieldMapChange(value, field)],
              density: "compact",
              class: "account-select",
              clearable: "",
              searchable: "",
              placeholder: "Map to ...",
              variant: "outlined",
              "hide-details": "true",
              "return-object": ""
            }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)], 512), [[_vShow, !(field.valueType == 'enum' && customFieldsState.disableDropdowns)]]), _withDirectives(_createElementVNode("td", null, [_createElementVNode("span", {
            class: _normalizeClass(field.map ? 'visible' : 'invisible')
          }, [_withDirectives(_createVNode(LlSecondaryButton, {
            type: "button",
            size: "small",
            onClick: $event => field.showValues = !field.showValues
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, "hide", 512), [[_vShow, field.showValues]]), _withDirectives(_createElementVNode("span", null, "map", 512), [[_vShow, !field.showValues]]), _cache[9] || (_cache[9] = _createTextVNode(" values ", -1))]),
            _: 2
          }, 1032, ["onClick"]), [[_vShow, field.valueType == 'enum']])], 2)], 512), [[_vShow, !customFieldsState.disableDropdowns]])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.values, value => {
            return _withDirectives((_openBlock(), _createElementBlock("tr", {
              key: value.name
            }, [_cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)), _createElementVNode("td", null, _toDisplayString(value.name), 1), _cache[11] || (_cache[11] = _createElementVNode("td", {
              colspan: "3"
            }, null, -1)), _createElementVNode("td", null, [_withDirectives(_createVNode(_component_v_card_text, {
              class: "py-2"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_autocomplete, {
                items: customFieldsState.users,
                "item-value": "id",
                "item-title": "name",
                modelValue: value.map,
                "onUpdate:modelValue": [$event => value.map = $event, _cache[1] || (_cache[1] = $event => changeLeanLawCustomField($event))],
                density: "compact",
                class: "account-select",
                clearable: "",
                searchable: "",
                placeholder: "Map to ...",
                variant: "outlined",
                "hide-details": "true",
                "return-object": ""
              }, {
                selection: _withCtx(({
                  item
                }) => [_createElementVNode("span", _hoisted_10, _toDisplayString(item.raw.name), 1)]),
                _: 1
              }, 8, ["items", "modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1536), [[_vShow, field.map?.type === 'user']]), _withDirectives(_createVNode(_component_v_card_text, {
              class: "py-2"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_autocomplete, {
                items: _unref(customFieldStore).matterTags,
                "item-value": "id",
                "item-title": "label",
                modelValue: value.map,
                "onUpdate:modelValue": [$event => value.map = $event, _cache[2] || (_cache[2] = $event => changeLeanLawCustomField($event))],
                density: "compact",
                class: "account-select",
                clearable: "",
                searchable: "",
                placeholder: "Map to ...",
                variant: "outlined",
                "hide-details": "true",
                "return-object": ""
              }, {
                selection: _withCtx(({
                  item
                }) => [_createElementVNode("span", _hoisted_11, _toDisplayString(item.raw.label), 1)]),
                _: 1
              }, 8, ["items", "modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1536), [[_vShow, field.map?.type === 'matterTag']])]), _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1))])), [[_vShow, field.showValues]]);
          }), 128))]);
        }), 128))]),
        _: 1
      }), _withDirectives(_createElementVNode("div", _hoisted_12, [customFieldsState.me?.features?.custom ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Your LeanLaw subscription includes integration with QuickBooks Advanced custom fields. To take advantage of this, you need to upgrade your QuickBooks subscription. ")) : _createCommentVNode("", true)], 512), [[_vShow, !customFieldsState.qboav]])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[13] || (_cache[13] = [_createElementVNode("p", null, "You don't have any Custom Fields defined in QuickBooks.", -1), _createElementVNode("p", null, " This feature depends on your QuickBooks subscription. QuickBooks Advanced users provides comprehensive custom fields, Essentials and Plus provide simple custom fields. Custom fields are used to tag invoices for reporting purposes, or for communicating information to clients. ", -1)]))])), _createVNode(SettingsSaveBar, {
        somethingChanged: customFieldsState.somethingChanged,
        saving: customFieldsState.saving,
        unsaved: customFieldsState.unsaved,
        onUpdate: update,
        onCancel: cancel
      }, null, 8, ["somethingChanged", "saving", "unsaved"])])])), _cache[14] || (_cache[14] = _createElementVNode("div", {
        style: {
          "height": "400px"
        }
      }, null, -1))], 64);
    };
  }
};